import * as React from "react";
import {Component} from "react";
import styles from "../styles/wizards/AddZoneWizard.scss";
import autobind from "autobind-decorator";
import AddZoneIcon from "../assets/images/add-zone-60x60.svg";
import {__, mapStateToProps, setTableParams, validateForm} from "../core/utils";
import {withRouter} from "react-router";
import {getStagesLanguages} from "../redux/actions/table/stages";
import {setNotification} from "../redux/actions/general/notification";
import {createZone, listZones} from "../redux/actions/table/zones";
import AddZoneForm from "../forms/add_zone_wizard/AddZoneForm";

@withRouter
@mapStateToProps(state => ({
	table: state.table["zones"],
}))
class AddZoneWizard extends Component {
	constructor(props) {
		super(props);

		this.state = {
			project_languages: null
		}
	}

	componentDidMount() {
		getStagesLanguages(this.props.match.params.stage).then(({response}) => {
			this.setState({project_languages: response.data});
		});
	}

	@autobind
	_handleSubmit(formData) {
		const {edit} = formData;

		formData = _.omit(formData, ['edit']);

		return validateForm(
			createZone(this.props.match.params.stage, formData).then(({response}) => {
				listZones(this.props.match.params.stage).then(() => {
					if(edit) {
						setTableParams('zones', {
							clicked_row: response.data.id
						});
					}
				});

				setTableParams('zones', {
					actioned_row: undefined,
					selected_rows: []
				});

				this.props.onClose();

				setNotification(__("wizard.add-zone.message.success"));
			})
		);
	}

	render() {
		return (
			<>
				<div className={styles.header}>
					<div className={styles.left}>
						<span>{__('wizard.add-zone.title.add-new-zone')}</span>
						<span>{__('wizard.add-zone.subtitle.add-new-zone')}</span>
					</div>
					<div className={styles.right}>
						<AddZoneIcon />
					</div>
				</div>
				<div className={styles.body}>
					{this.state.project_languages && <AddZoneForm
						projectLanguages={this.state.project_languages}
						onSubmit={this._handleSubmit}
						initialValues={{
							title: {},
							description: {},
						}}
					/>}
				</div>
			</>
		);
	}
}

export default AddZoneWizard;